import "./index.css";
import { useState } from "react";
import { useEffect } from "react";
import CompanyComponent, {
  AddLocation,
  ModalAddLocation,
  ModalCompanyDetail,
} from "../../components/CompanyComponent";
import {
  getBusinessList,
  getBusinessDetail,
  getFirstBusiness,
} from "../../apis/Business/Business";
import { Link } from "react-router-dom";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AccountContext, ContainerBody } from "../../App";
import Franchises from "./Franchises";
import Investments from "./Investments";
import { createContext, useContext } from "react";
import { YearTabContext } from "../../components/Skeleton";
import { getAccountInfo } from "../../apis/User";
import { useUserAccess } from "../../components/WriteAccessContext";
import EPRBox from "./EPR";
import CompanyIntro from "./CompanyIntro";

const bg = () => {
  return (
    <svg
      width="980"
      height="6677"
      viewBox="0 0 980 6677"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
    >
      <path
        opacity="0.2"
        d="M958.98 6677.16C669.65 6683.84 323.28 6675.25 20.9796 6677.16C11.4096 6669.76 7.19954 6659.23 5.17954 6652.24C1.37954 6639.1 1.80954 6616.42 2.81954 6571.6C3.13954 6557.6 3.29953 6556.31 3.43953 6545.79C3.80954 6516.94 2.95954 6495.87 2.81954 6491.79C0.899543 6437.08 1.38977 764.124 2.41977 519.484C5.08977 -115.366 -28.2002 17.2736 103.42 2.0136C249.57 2.0136 375.961 2.5936 511.771 2.8136C683.341 -0.916408 776.451 3.17361 959.551 2.0436C985.181 6.62361 976.831 69.8236 977.331 106.334C977.791 135.034 979.031 167.804 977.421 207.334C977.141 267.334 978.331 395.924 979.091 471.704C974.491 1555.83 987.79 6646.04 958.98 6677.16Z"
        fill="#C4D4CC"
      />
    </svg>
  );
};

export const DropdownInvestmentContext = createContext();

const Company = () => {
  const [locationResponse, setLocationResponse] = useState({});
  const [locations, setLocations] = useState([
    //{
    // "address_line_1":"House no.45 second floor",
    // "address_line_2": "5th cross. Banaswadi",
    // "city" :"Bangalore",
    // "postcode":"560043"}
  ]);
  const yearTab = useContext(YearTabContext);
  const [businessId, setBusinessId] = useState("");

  const [addLocation, setAddLocation] = useState(false);
  const [detailLocation, setDetailLocation] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [activeMainBusinessName, setActiveMainBusinessName] = useState(null);
  const { setUserAccessType, setIsShare } = useUserAccess();
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");

  const handleToggleActive = (mainBusinessName) => {
    setActiveMainBusinessName(mainBusinessName);
  };

  const [businessName, setBusinessName] = useState("");

  const { setAccount } = useContext(AccountContext);

  const { t } = useTranslation();

  const handleClose = (setter) => {
    document.getElementsByTagName("body")[0].className = "";
    setter(false);
    getBusinessList({ setLocations: setLocations, filterYear: yearTab });
  };

  useEffect(() => {
    if (activeMainBusinessName === null) {
      setUserAccessType("write");
    }
  }, [activeMainBusinessName]);

  useEffect(() => {
    if (yearTab) {
      getBusinessList({
        setLocations: setLocations,
        filterYear: yearTab,
        setResponse: setLocationResponse,
      });
      getFirstBusiness({
        setCompanyname: setCompanyName,
        setAddress: setAddress,
      });
      getBusinessDetail({
        id: localStorage.getItem("id_business"),
        setName: setBusinessName,
      });
    } else {
      async function fetchData() {
        // await getBusinessList({
        //   setLocations: setLocations,
        //   setResponse: setLocationResponse,
        // });
        const account = await getAccountInfo();
        setAccount(account.data.data);
      }
      fetchData();
    }
  }, [yearTab, setAccount]);

  const sortByCountry = useCallback(() => {
    const result = {};
    Array.isArray(locations) &&
      locations.map((location) => {
        const splitted = location["address1"]
          ? location["address1"].split(",")
          : [""];

        result[splitted[splitted.length - 1]] = result[
          splitted[splitted.length - 1]
        ]
          ? [...result[splitted[splitted.length - 1]], location]
          : [location];
      });
    return result;
  }, [locations]);

  useEffect(() => {}, [locations]);

  const handleDetailModal = (id) => {
    setDetailLocation(true);
    setBusinessId(id);
  };

  // const dropdownInvestment = [
  //     {id:1,name:"Subsidiary (own +50%)",value:"Subsidiary (own +50%)"},
  //     {id:2,name:"Associate company (own 20-50%)",value:"Associate company (own 20-50%)"},
  //     {id:3,name:"Joint Venture",value:"Joint Venture"},
  //     {id:4,name:"Under 20% Ownership",value:"Under 20% Ownership"},
  // ]

  const [dropdownInvestment, setDropdownInvestment] = useState([
    {
      id: 1,
      name: t("Subsidiary (own +50%)"),
      value: t("Subsidiary (own +50%)"),
    },
    {
      id: 2,
      name: t("Associate company (own 20-50%)"),
      value: t("Associate company (own 20-50%)"),
    },
    { id: 3, name: t("Joint Venture"), value: t("Joint Venture") },
    { id: 4, name: t("Under 20% Ownership"), value: t("Under 20% Ownership") },
  ]);

  useEffect(() => {
    setDropdownInvestment([
      {
        id: 1,
        name: t("Subsidiary (own +50%)"),
        value: t("Subsidiary (own +50%)"),
      },
      {
        id: 2,
        name: t("Associate company (own 20-50%)"),
        value: t("Associate company (own 20-50%)"),
      },
      { id: 3, name: t("Joint Venture"), value: t("Joint Venture") },
      {
        id: 4,
        name: t("Under 20% Ownership"),
        value: t("Under 20% Ownership"),
      },
    ]);
  }, [t]);

  return (
    // <Skeleton
    // content={

    <>
      {addLocation ? (
        <ModalAddLocation
          locations={locations}
          setLocations={setLocations}
          closeModal={() => handleClose(setAddLocation)}
        />
      ) : null}
      {detailLocation ? (
        <ModalCompanyDetail
          businessId={businessId}
          closeModal={() => handleClose(setDetailLocation)}
        />
      ) : null}
      {addLocation ? (
        <div
          className="background__modal"
          onClick={() => handleClose(setAddLocation)}
        ></div>
      ) : null}
      {detailLocation ? (
        <div
          className="background__modal"
          onClick={() => handleClose(setDetailLocation)}
        ></div>
      ) : null}

      <ContainerBody className="company__body">
        {/* <div className="company__body__extrainfo">
                <img src={mark} alt="" />
                <h4>This mark indicates that your product information has ben fully filled in</h4>
            </div> */}
        <div className="company__body__items">
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div
              className={`companydetail__info__label ${
                activeMainBusinessName === null ? "active" : ""
              }`}
              onClick={() => {
                setLocations(locationResponse.data);
                setUserAccessType("write");
                handleToggleActive(null);
                setIsShare(false);
              }}
              style={{
                cursor: "pointer",
              }}
            >
              <h6>{businessName ? businessName : t("Branches")}</h6>
            </div>
            {locationResponse.shared &&
              Object.keys(locationResponse.shared).map((mainBusinessName) => (
                <div
                  key={mainBusinessName}
                  className={`companydetail__info__label ${
                    activeMainBusinessName === mainBusinessName ? "active" : ""
                  }`}
                  onClick={() => {
                    setLocations(locationResponse.shared[mainBusinessName]);
                    setUserAccessType(
                      locationResponse.read_or_write[mainBusinessName][0]
                        .is_write
                    );
                    setIsShare(true);
                    handleToggleActive(mainBusinessName);
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <h6>{mainBusinessName}</h6>
                </div>
              ))}
          </div>
          <CompanyIntro />
          <EPRBox />

          <div className="company__component__country">
            <div className="company__body__items mt-2 ms-4">
              {Object.entries(sortByCountry()).map(([key, locations]) => {
                return (
                  <>
                    <div className="companydetail__info__label">
                      <h6>
                        {t("COUNTRY")}: {key}
                      </h6>
                    </div>
                    <div className="company__component__country">
                      {Array.isArray(locations) &&
                        locations.map((location, i) => {
                          return (
                            <Link
                              className="nav-link"
                              to={"/company/" + location.id}
                            >
                              <CompanyComponent
                                index={i}
                                name={location.name}
                                address_line_1={location.address1}
                                address_line_2={location.address2}
                                city={location.country}
                                postcode={location.post_code}
                                location_number={location.location_number}
                                detailModal={() =>
                                  handleDetailModal(location.id)
                                }
                              />
                            </Link>
                          );
                        })}
                    </div>
                  </>
                );
              })}
              {/* <div className="companydetail__info__label">
                <h6>
                    Country: Denmark
                </h6>
            </div>
            <div className="company__component__country">
            {
                locations && locations.length >= 1 ?
                locations.map((location,i) => {
                    return <Link className="nav-link" to={"/company/"+location.id}>
                    <CompanyComponent index={i} address_line_1={location.address1}
                        address_line_2={location.address2}
                        city={location.country}
                        postcode={location.post_code}
                        location_number={location.location_number}
                        detailModal={()=> handleDetailModal(location.id)}/>
                    </Link>
                }):null

            }
            </div> */}

              <div style={{ display: "flex", marginTop: "10px" }}>
                <Link
                  className="nav-link"
                  to={"/company/add?year=" + (year ? year : yearTab)}
                >
                  <AddLocation />
                </Link>
                {/* <Link className="nav-link" to={"/company/epr?year=" + yearTab}>
                  <EPREconomic />
                </Link> */}
              </div>
            </div>
          </div>
        </div>
        <DropdownInvestmentContext.Provider value={dropdownInvestment}>
          <Franchises />
          <Investments />
        </DropdownInvestmentContext.Provider>
      </ContainerBody>
    </>
    // }
    // />
  );
};
export default Company;
